const BlobModel = require('common/domain/entity/blob');
const BlobCollection = require('common/domain/collection/blob');
const MarkdownWriterTemplate = require('common/ui/template/markdown/writer.hbs');
const BlobUploader = require('common/ui/view/blob/uploader');
const BlobSelectorView = require('common/ui/view/blob/selector');
const DataContentSelectorView = require('balus/ui/view/modal/data-content-selector');
const ModalView = require('common/ui/view/modal/index');
const Marked = require('balus/util/marked');
const i18n = require('i18next');
const Mn = require('backbone.marionette');

module.exports = Mn.View.extend({
    template: MarkdownWriterTemplate,
    ui: {
        'writer': '.markdown-writer textarea',
        'uploader': '.uploader'
    },
    events: {
        'change @ui.writer': 'onChange',
        'keyup @ui.writer': 'onChange',
        'cut @ui.writer': 'onChange',
        'input @ui.writer': 'onChange',
        'paste @ui.writer': 'onPaste',
        'click .select-data-content': 'showDataContentSelector',
        'click .blob-selector': 'showBlobSelector'
    },

    triggers: {
        'focus @ui.writer': {
            event: 'focus',
            preventDefault: false,
            stopPropagation: false
        },
        'blur @ui.writer': {
            event: 'blur',
            preventDefault: false,
            stopPropagation: false
        }
    },
    regions: {
        dataContentSelector: '.data-content-selector'
    },

    // 添付ボタンを表示して markdown に Data Content を挿入できるようにする
    useDataContentSelector: false,
    // 添付ボタンを表示して markdown に Blob を挿入できるようにする
    useBlobSelector: false,
    useUploader: false,
    // textarea の row 数
    rows: 10,
    placeholder: '',

    /**
     * Markdown を記入してプレビューを見られるようにする View
     *
     * params.markdown で初期データを渡し、
     * 変更後の markdown は `change` event の第一引数で
     * 随時渡ってくる。
     *
     * 他に params.rows で入力エリアの rows を指定可能(default 10)、
     * params.placeholder で placeholder を指定可能。
     * @param params
     */
    initialize: function(params) {
        _.bindAll(this,
            'successUpload',
            'onPaste', 'getUploadUrl', 'setUploadUrl');
        this._markdown = params.markdown ? params.markdown : '';
        this._id = params.id ? params.id : Math.floor((Math.random() * 100000));
        this._blobApi= params.blobApi;
        this._marked = params.marked ? params.marked : Marked();
        this._useWideEditor = params.useWideEditor ? params.useWideEditor : false;
        this._wideModalTitle = params.wideModalTitle ? params.wideModalTitle : null;
        this._blobs = new BlobCollection();

        if (this.getOption('useUploader') ||
            this.getOption('useBlobSelector')) {
            this.getUploadUrl();
        }
    },

    templateContext: function() {
        return {
            markdown: this._markdown,
            id: this._id,
            placeholder: this.getOption('placeholder'),
            useBlobSelector: this.getOption('useBlobSelector'),
            useDataContentSelector: this.getOption('useDataContentSelector'),
            useWideEditor: this._useWideEditor,
            wideModalTitle: this._wideModalTitle
        }
    },

    onRender: function() {
        this.updateRows(this.getOption('rows'));
        this.ui.writer.attr('placeholder', this._placeholder);
        const project = this.getOption('project');

        if(this.getOption('useUploader')) {
            this._blobUploader = new BlobUploader({
                blobApi: this._blobApi,
                onSuccess: this.successUpload
            });
            this.ui.uploader.append(this._blobUploader.render().$el);
        }

        // markdown に Data Content を挿入できるようにする
        else if(this.getOption('useDataContentSelector')) {
            this.showChildView('dataContentSelector', new DataContentSelectorView({
                project: project
            }));
            this.listenTo(this.getChildView('dataContentSelector'), 'select', function (content) {
                this.trigger('insert', content);
                this.append(content.toMarkdown());
                this.getChildView('dataContentSelector').hide();
            });
        }

        return this;
    },

    onDomRefresh() {
        $.material.init();

        if(this.getOption('autoFocus')) {
            this.focus();
        }
    },

    onDestroy: function() {
        if(this._blobUploader) {
            this._blobUploader.remove();
        }
        if(this._blobSelector) {
            this._blobSelector.remove();
        }
    },

    onChange: function() {
        this._markdown = this.ui.writer.val();
        this.trigger('change', this._markdown);
    },

    update: function(markdown) {
        this.ui.writer.val(markdown);
        this.onChange();
    },

    append: function(str) {
        var val = this.ui.writer.val();
        if(val != '') {
            if(!val.match(/\s$/)) {
                val = val + '\n' + str;
            } else {
                val = val + str;
            }
        } else {
            val = str;
        }
        this.ui.writer.val(val);
        this.onChange();
    },

    updateRows: function(rows) {
        this.ui.writer.attr('rows', rows);
    },

    replace: function(replaceStr, str) {
        var val = this.ui.writer.val();
        if (val != '') {
            val = val.replace(replaceStr, str);
        }
        this.ui.writer.val(val);
        this.onChange();
    },

    clear: function() {
        this.ui.writer.val('');
    },

    focus: function() {
        this.ui.writer.focus();
    },

    getUploadUrl: function() {
        $.ajax({
            type: 'POST',
            url: this._blobApi.path(),
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            timeout: 10000
        })
            .done(this.setUploadUrl);
    },

    showDataContentSelector: function() {
        this.getChildView('dataContentSelector').show();
    },

    setUploadUrl: function(data) {
        this.uploadUrl = data.upload_url;
    },

    onPaste: function(event) {
        // event からクリップボードのアイテムを取り出す (Firefox, Safari 等ではサポートされていない)
        const items = event.originalEvent.clipboardData.items;
        let file;
        _.each(items, function(item) {
            if (item.kind == 'file') {
                file = item.getAsFile();
            }
        }, this);

        if(file) {
            this.trigger('paste:file', file);
            return false;
        }
    },

    successUpload: function(file, blob) {
        this.append(blob.getMarkdownLink());
        this._blobs.add(blob);
    },

    showBlobSelector: function(){
        // markdown に Blob を挿入できるようにする
        this._blobSelector = new ModalView({
            title: i18n.t('blobSelector.title.normal'),
            bodyView: new BlobSelectorView({
                blobs: this._blobs,
                multiple: true,
                useUploader: true,
                blobApi: this._blobApi
            }),
            onChildviewSave: function() {
                this.disableButtons();
                this.getOption('bodyView').select()
                    .then((blobs) => {
                        this.trigger('selected', blobs);
                        this.hide();
                    });
            }
        });
        this._blobSelector.show();

        this.listenTo(this._blobSelector, 'selected', function(blobs) {
            _.each(blobs, _.bind(function(blob) {
                this.append('\n' + blob.getMarkdownLink());
            }, this));
        });
        this._blobs.fetch({url: this._blobApi.path()});
    },

    getTextRows: function() {
        const textHeight = this.ui.writer.get(0).scrollHeight;
        const writerHeight = this.ui.writer.height();
        const writerRows = Number(this.ui.writer.attr('rows'));
        const lineHeight = writerHeight / writerRows;

        return Math.floor(textHeight / lineHeight);
    },

    disabled: function() {
        this.ui.writer.prop("disabled", true);
    },

    enabled: function() {
        this.ui.writer.prop("disabled", false);
    }


});



// WEBPACK FOOTER //
// ./common/ui/view/markdown/writer.js